import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Welcome',
    props: {
        common: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Welcome Vue", -1)),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
